module.exports = __webpack_public_path__ + "img/5-3.33477c83.jpg";